<template lang="html">
  <div v-show="this.settings !== undefined && this.settings.enableZoomToAds === 1" class="zoom-area-layer" :id="_uid + '-zoom-area-layer'" @click="zoomAreaClicked()">
  </div>
</template>

<script>

import {
  mapGetters
} from 'vuex'

export default {
  props: ['zoomObj'],
  data () {
    return {
    }
  },
  created () {
  },
  mounted () {
    var div = document.getElementById(this._uid + '-zoom-area-layer')
    var box1 = this.getBox(this.zoomObj)
    var box2 = this.getBox(this.zoomObj.page)

    var x = box1.x / box2.width
    var y = box1.y / box2.height
    var width = box1.width / box2.width
    var height = box1.height / box2.height

    if (width > 1) {
      width = 1
    }

    div.style.left = x * 100 + '%'
    div.style.top = y * 100 + '%'
    div.style.width = width * 100 + '%'
    div.style.height = height * 100 + '%'

    this.setZindexesForZoomAreas()
  },
  computed: {
    ...mapGetters({
      opsUrl: 'getOpsUrl',
      isScrolling: 'getIsScrolling',
      settings: 'getSettings',
      isFullPageViewMode: 'getPageViewMode'
    })
  },
  watch: {

  },
  methods: {
    zoomAreaClicked () {
      if (!this.isScrolling && this.isFullPageViewMode) {
        const div = document.getElementById(this._uid + '-zoom-area-layer')
        if (this.$parent.zoomer.scale === 1) {
          this.$parent.zoomer.zoomToElement(div)
        } else if (this.isZoomAreaInViewport()) {
          this.$parent.zoomToLevel(1.0)
        }
      }
    },
    getBox (obj) {
      return {
        x: parseFloat(obj.attributes.ObjectXPos),
        y: parseFloat(obj.attributes.ObjectYPos),
        width: parseFloat(obj.attributes.ObjectWidth),
        height: parseFloat(obj.attributes.ObjectHeight)
      }
    },
    setZindexesForZoomAreas () {
      var divs = document.getElementsByClassName('zoom-area-layer')
      var divArray = []
      for (var i = 0; i < divs.length; i++) {
        // divs[i].style.zIndex = i
        divArray.push(divs[i])
      }

      divArray.sort(this.sortBy(true))

      for (var j = 0; j < divArray.length; j++) {
        divArray[j].style.zIndex = j
      }
    },
    sortBy (reverse) {
      // Move smaller items towards the front
    // or back of the array depending on if
    // we want to sort the array in reverse
    // order or not.
      var moveSmaller = reverse ? 1 : -1

    // Move larger items towards the front
    // or back of the array depending on if
    // we want to sort the array in reverse
    // order or not.
      var moveLarger = reverse ? -1 : 1

    /**
     * @param  {*} object1
     * @param  {*} object2
     * @return {Number}
     */
      return function (object1, object2) {
        if ((object1.getBoundingClientRect().width * object1.getBoundingClientRect().height) < (object2.getBoundingClientRect().width * object2.getBoundingClientRect().height)) {
          return moveSmaller
        }
        if ((object1.getBoundingClientRect().width * object1.getBoundingClientRect().height) > (object2.getBoundingClientRect().width * object2.getBoundingClientRect().height)) {
          return moveLarger
        }
        return 0
      }
    },
    getZoomObjectIfInCenter () {
      // TODO: This may be useful for some tracking
      const div = document.getElementById(this._uid + '-zoom-area-layer')
      const rect = div.getBoundingClientRect()

      const windowWidth = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth
      const windowHeight = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight
      const centerX = windowWidth / 2
      const centerY = windowHeight / 2

      const isInCenter = (
        rect.bottom >= centerY &&
        rect.top < centerY &&
        rect.left <= centerX &&
        rect.right > centerX
      )

      if (isInCenter) return this.zoomObj
    },
    isZoomAreaInViewport () {
      const zoomAreadiv = document.getElementById(this._uid + '-zoom-area-layer')
      const zoomAreaRect = zoomAreadiv.getBoundingClientRect()
      return (
        zoomAreaRect.top >= 0 &&
        zoomAreaRect.left >= 0 &&
        zoomAreaRect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        zoomAreaRect.right <= (window.innerWidth || document.documentElement.clientWidth)
      )
    }
  }
}
</script>

<style lang=scss>
.zoom-area-layer {
  width: 100%;
  position: absolute;
  cursor: pointer;
}
</style>
